import Vue from 'vue';
import analysis from '@xy/analysis';

const PROJECT_SPM = 'VATEASE_CLIENT';

analysis.init({
  data: {
    env: process.env.NODE_ENV === 'production' ? 'prod' : 'dev',
    biz_source: 'BBMALL',
  },
  config: {
    dsn:
      process.env.NODE_ENV === 'production' ? 'https://xyplus.xyb2b.com/xy.gif' : 'http://xyplus.xyb2b.com.cn/xy.gif',
  },
  debug: false,
});

const getPage = (path = window.location.pathname) => {
  const route = routes.find((item, spm) => `/client${item.path}`.startsWith(path));
  return route
    ? {
        spm: String(route.spm),
        title: route.name,
      }
    : {
        spm: '0',
        title: '',
      };
};

const constructTrackData = (value) => {
  const data = typeof value === 'function' ? value() : value;
  const currentPage = getPage();
  const userInfo = JSON.parse(localStorage.getItem('objInfo'));
  return {
    ...data,
    spm: data.spm.includes('.') ? data.spm : `${PROJECT_SPM}.${currentPage.spm}.${data.spm}`,
    params: {
      ...(data.params || {}),
      userId:userInfo? userInfo.userId:'',
      phone:userInfo? userInfo.account:'',
    },
  };
};

Vue.directive('trackClick', {
  inserted: function (el, binding) {
    const value = binding.value;
    if (!value) return;

    el.addEventListener('click', () => {
      analysis.trackEvent.click(constructTrackData(value));
    });
  },
});

Vue.directive('trackExposure', {
  inserted: function (el, binding) {
    const value = binding.value;
    if (!value) return;

    const ob = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          analysis.trackEvent.exposure(constructTrackData(value));
          ob.unobserve(el);
        }
      });
    });
    ob.observe(el);
  },
});

export const reportPv = (path) => {
  const currentPage = getPage(path);
  const trackData = {
    spm: `${PROJECT_SPM}.${currentPage.spm}`,
    params: { title: currentPage.title },
  };
  analysis.trackEvent.view(trackData);
};

const routes = [
  {
    path: '/work',
    name: '工作台',
    spm: 1,
  },
  {
    path: '/serviceList',
    name: '工作台',
    spm: 2,
  },
  {
    path: '/user',
    name: 'user',
    spm: 3,
  },
  {
    path: '/receiveCoupon',
    name: '领劵中心',
    spm: 4,
  },
  {
    path: '/coupon',
    name: '我的优惠券',
    spm: 5,
  },
  {
    path: '/myInvite',
    name: '我邀请的用户',
    spm: 6,
  },
  {
    path: '/securitySetting',
    name: '安全设置',
    spm: 7,
  },
  {
    path: '/monitor',
    name: '跟卖监控管理',
    spm: 8,
  },
  {
    path: '/shoppingCart',
    name: '购物车',
    spm: 9,
  },
  {
    path: '/sureOrder',
    name: '确认订单',
    spm: 10,
  },
  {
    path: '/pay',
    name: '订单支付',
    spm: 11,
  },
  {
    path: '/oaPaid',
    name: '确认订单',
    spm: 12,
  },
  {
    path: '/login',
    name: '登录',
    spm: 13,
  },
  {
    path: '/en/login',
    name: '英文登录',
    spm: 14,
  },
  {
    path: '/serviceDetail',
    name: '商品详情',
    spm: 15,
  },
  {
    path: '/infoDetail',
    name: '商标详情',
    spm: 16,
  },
  {
    path: '/fillEvidence',
    name: '使用证据',
    spm: 17,
  },
  {
    path: '/adjustCate',
    name: 'AdjustCate',
    spm: 18,
  },
  {
    path: '/useEvidence',
    name: 'UseEvidence',
    spm: 19,
  },
  {
    path: '/orderList',
    name: '我的订单',
    spm: 20,
  },
  {
    path: '/invoiceList',
    name: '我的发票',
    spm: 21,
  },
  {
    path: '/invoiceDetails',
    name: '我的发票详情',
    spm: 22,
  },
  {
    path: '/myPatent',
    name: '我的专利',
    spm: 23,
  },
  {
    path: '/myPatent/detail/:id',
    name: '专利详情',
    spm: 24,
  },
  {
    path: '/myPatent/fillInfomation/:id',
    name: '填写资料',
    spm: 25,
  },
  {
    path: '/myPatent/succeed/:serviceId',
    name: '资料提交成功',
    spm: 26,
  },
  {
    path: '/myBrand',
    name: '我的商标',
    spm: 27,
  },
  {
    path: '/myBrand/detail',
    name: '商标详情',
    spm: 28,
  },
  {
    path: '/reviewOpinions',
    name: '审查意见',
    spm: 29,
  },
  {
    path: '/reviewOpinions/Details',
    name: '审查意见详情',
    spm: 30,
  },
  {
    path: '/reviewOpinions/choosePlan',
    name: '审查意见选择方案',
    spm: 31,
  },
  {
    path: '/patent',
    name: '我的专利',
    spm: 32,
  },
  {
    path: '/patent/detail',
    name: '我的专利详情',
    spm: 33,
  },
  {
    path: '/otherTrademark',
    name: '其他商标服务',
    spm: 34,
  },
  {
    path: '/otherTrademark/detail',
    name: '其他商标服务详情',
    spm: 35,
  },
  {
    path: '/stationLetter',
    name: '消息通知',
    spm: 36,
  },
  {
    path: '/trademarkMonitor',
    name: '商标监控',
    spm: 37,
  },
  {
    path: '/trademarkMonitor/Details',
    name: '商标监控详情',
    spm: 38,
  },
  {
    path: '/activity/crazyThursday',
    name: '疯狂星期四',
    spm: 39,
  },
  {
    path: '/activity/sevenYears',
    name: '七周年',
    spm: 40,
  },
  {
    path: '/activity618',
    name: '618秒杀',
    spm: 41,
  },
  {
    path: '/activity',
    name: '活动页面',
    spm: 42,
  },
  {
    path: '/lottery',
    name: '抽奖活动',
    spm: 43,
  },
  {
    path: '/trademarkName',
    name: '商标核名',
    spm: 44,
  },
  {
    path: '/trademarkMonitoring',
    name: '我收藏的商标',
    spm: 45,
  },
  {
    path: '/trademarkCollect',
    name: '我收藏的起名',
    spm: 46,
  },
  {
    path: '/myCollection',
    name: '我的收藏',
    spm: 47,
  },
  {
    path: '/integralMal',
    name: '积分商城',
    spm: 48,
  },
  {
    path: '/address',
    name: '地址管理',
    spm: 49,
  },
  {
    path: '/address/edit',
    name: '地址编辑',
    spm: 50,
  },
  {
    path: '/paymentSucceeded',
    name: '支付成功',
    spm: 51,
  },
  {
    path: '/submittedSucceeded',
    name: '提交成功',
    spm: 52,
  },
  {
    path: '/payment',
    name: 'Payment',
    spm: 53,
  },
  {
    path: '/paymentSuccess',
    name: 'PaymentSuccess',
    spm: 54,
  },
  {
    path: '/paymentFail',
    name: 'PaymentFail',
    spm: 55,
  },
  {
    path: '/trademarkNameReviewReport',
    name: 'TrademarkNameReviewReport',
    spm: 56,
  },
  {
    path: '/monitoringReport',
    name: '监控报告',
    spm: 57,
  },
  {
    path: '/monitoringDetails',
    name: '监控详情',
    spm: 58,
  },
  {
    path: '/monitoringSubscription',
    name: 'monitoringSubscription',
    spm: 59,
  },
  {
    path: '/monitorSubscriptionAdmin',
    name: 'monitorSubscriptionAdmin',
    spm: 60,
  },
  {
    path: '/userAgreement',
    name: '用户协议',
    spm: 61,
  },
  {
    path: '/privacyPolicy',
    name: '隐私政策',
    spm: 62,
  },
  {
    path: '/anniversary',
    name: '周年庆',
    spm: 63,
  },
  {
    path: '/industryReport',
    name: '行业报告',
    spm: 64,
  },
  {
    path: '/industryReportDetail',
    name: '行业报告详情',
    spm: 65,
  },
];



// WEBPACK FOOTER //
// ./src/directive/analysis.js